import { useEffect, useState } from "react";
import ModalComponent from "../../components/modals";
import SimpleTable from "../../components/tables/simpleTable";
import {
  indicatorTableColumns,
  indicatorTableColumnsUnplanned
} from "./tableColumns";
import { icons } from "../../constants";
import {
  getExecutedVsNoProjectedDetailData,
  getExecutedVsProjectedDetailData,
  getIndicatorUnplannedExecutedDetailsData
} from "./getIndicatorData";
import TaskDayCommentsModal from "./taskDayCommentsModal";

const pad2 = (n) => String(n).padStart(2, "0");

const toMysqlDate = (d) => {
  const dt = new Date(d);
  return `${dt.getFullYear()}-${pad2(dt.getMonth() + 1)}-${pad2(dt.getDate())}`;
};

const TaskListDetailModal = ({
  open,
  onClose,
  user_data,
  year,
  month,
  range,
  year2,
  month2,
  range2,
  type
}) => {
  const [detailPage, setDetailPage] = useState(1);
  const [selectedTask, setSelectedTask] = useState(null);
  const [openComments, setOpenComments] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [detailTotal, setDetailTotal] = useState(0);

  const ROWS_PER_PAGE = 10;

  const responsibleId = user_data?.responsible_id ?? null;
  const userName = user_data?.responsible ?? null;

  const effectiveYear = type === "unplanned" ? year2 : year;
  const effectiveMonth = type === "unplanned" ? month2 : month;
  const effectiveRange = type === "unplanned" ? range2 : range;

  const loadData = () => {
    if (type === "unplanned") {
      getExecutedVsNoProjectedDetailData(
        effectiveYear,
        effectiveMonth,
        effectiveRange,
        setTableData,
        setDetailTotal,
        setDetailPage,
        detailPage,
        ROWS_PER_PAGE,
        responsibleId
      );
    } else {
      getExecutedVsProjectedDetailData(
        effectiveYear,
        effectiveMonth,
        effectiveRange,
        setTableData,
        setDetailTotal,
        setDetailPage,
        detailPage,
        ROWS_PER_PAGE,
        responsibleId
      );
    }
  };

  const getPageData = (page = 1) => {
    if (type === "unplanned") {
      getExecutedVsNoProjectedDetailData(
        effectiveYear,
        effectiveMonth,
        effectiveRange,
        setTableData,
        setDetailTotal,
        setDetailPage,
        page,
        ROWS_PER_PAGE,
        responsibleId
      );
    } else {
      getExecutedVsProjectedDetailData(
        effectiveYear,
        effectiveMonth,
        effectiveRange,
        setTableData,
        setDetailTotal,
        setDetailPage,
        page,
        ROWS_PER_PAGE,
        responsibleId
      );
    }
  };

  const handlePageChange = (newPage) => {
    setDetailPage(newPage);
    getPageData(newPage);
  };

  useEffect(() => {
    if (open && responsibleId) {
      setDetailPage(1);
      getPageData(1);
    }
  }, [open, responsibleId, type, effectiveYear, effectiveMonth, effectiveRange]);

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={onClose}
        title={<>{userName} - Detalle de actividades</>}
      >
        <div className="VContainer">
          <SimpleTable
            columns={
              type === "unplanned"
                ? indicatorTableColumnsUnplanned
                : indicatorTableColumns
            }
            data={tableData}
            isPaginated={true}
            onPageChange={handlePageChange}
            serverPagination={true}
            totalRecords={detailTotal}
            rowsPerPage={ROWS_PER_PAGE}
            currentPage={detailPage}
            emptyMessage={"No hay actividades para los filtros seleccionados"}
            buttons={[
              {
                type: "icon",
                icon: icons.expediente_blue,
                onClick: (data) => {
                  setOpenComments(true);
                  setSelectedTask(data);
                }
              }
            ]}
          />
        </div>
      </ModalComponent>
      <TaskDayCommentsModal
        open={openComments}
        onClose={() => setOpenComments(false)}
        task={selectedTask}
        defaultDate={new Date()}
      />
    </>
  );
};

export default TaskListDetailModal;
